<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<!-- <span>时间周期：</span> -->
				<!-- <el-select v-model="timeType" class="time-type-select" size="small">
					<el-option :value="1" label="下单时间"></el-option>
					<el-option :value="0" label="备货时间"></el-option>
				</el-select> -->
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable='false'
					type="datetimerange"
					align="right"
					style="width:405px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-NO-box">
				<span>商品名称：</span>
				<el-input v-model="pname" placeholder="请输入商品名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>规格：</span>
				<el-input v-model="spec" placeholder="请输入规格" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" filterable multiple collapse-tags class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>第三方编号：</span>
				<el-input v-model="matchCode" placeholder="请输入第三方编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			timeType: 1,
			customerName: '',
			customerCode: '',
			matchCode: '',
			bigcategoryview: null,
			bigcategoryid: [],
			smallcategoryid: [],
			customerCategoryId: [],
			bc: [],
			sc: [],
			pcode: '',
			pname: '',
			spec: '',
			liquidateflag: '',
			orderstatus: [],
			dateValue: [],
			customList: [],
			collapse: true,
			bigcategoryidLength: 0,
			giftFlag: '全部',
			customercategoryid: []
		}
	},
	created () {
		this.initFilters()
		// this.getBigCategory()
		this.getCustomer()
		this.checkSmallCategory()
	},
	methods: {
		clearSearch () {
			this.timeType = 1
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.pname = ''
			this.pcode = ''
			this.matchCode = ''
			this.liquidateflag = ''
			this.customerName = ''
			this.customerCode = ''
			this.bigcategoryid = []
			this.customerCategoryId = []
			this.smallcategoryid = []
			this.orderstatus = []
			this.giftFlag = '全部'
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		bcChange (value) {
			if (this.bigcategoryview === 1 && value.length > 0) {
				if (value.length > this.bigcategoryidLength) {
					this.bigcategoryidLength = value.length
				} else {
					this.smallcategoryid = []
				}
				this.getSmalCategory()
			}	else {
				this.sc = []
				this.smallcategoryid = []
				this.getSmalCategory()
			}
		},
		removeBigCategoryid () {
			this.smallcategoryid = []
		},
		getSmalCategory () {
			let params = {
				pids: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
			// })
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.throughParams)
				let throughParams = this.$fxUtils.JSONparse(Params)
				if (throughParams) {
					this.pname = (throughParams.pname && throughParams.pname.value) || ''
					this.spec = (throughParams.spec && throughParams.spec.value) || ''
					let startDate = throughParams.startDate.value.split(' ')
					let endDate = throughParams.endDate.value.split(' ')
					this.dateValue = [startDate[0] + ` ${startDate[1].substring(0, 5)}`, endDate[0] + ` ${endDate[1].substring(0, 5)}`]
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'beginDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'endDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
			]
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			// if (this.orderType !== '全部') {
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'beginDate', data: ``, 'op': 'ge', name: '时间周期' },
					{ field: 'endDate', data: ``, 'op': 'le', name: '时间周期' }
				]
			} else {
				if (this.timeType === 1) {
					filtersParams = [
						{ field: 'beginDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '时间周期' },
						{ field: 'endDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '时间周期' }
					]
				} else {
					filtersParams = [
						{ field: 'beginDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '时间周期' },
						{ field: 'endDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '时间周期' }
					]
				}
			}
			if (this.pname !== '') {
				let pname = { 'field': 'pname', 'data': this.pname, 'op': 'cn' }
				filtersParams.push(pname)
			}
			if (this.spec !== '') {
				let spec = { 'field': 'spec', 'data': this.spec, 'op': 'cn' }
				filtersParams.push(spec)
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customerName', 'data': this.customerName, 'op': 'cn' }
				filtersParams.push(customerNameObj)
			}
			if (this.customercategoryid.length !== 0) {
				let customercategoryid = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryid)
			}
			if (this.matchCode !== '') {
				let matchCode = { 'field': 'matchCode', 'data': this.matchCode, 'op': 'cn' }
				filtersParams.push(matchCode)
			}
			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 105px;
				text-align: right
			}
		}
		.data-picker-box {
			// margin-right:10px
			.time-type-select {
				width:100px;
				margin-right:5px
			}
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
